import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminForwardingService} from '../../control/admin-forwarding.service';
import {QueueStats} from '../../entity/forwarding.model';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {LocalizationService} from '../../../localization/control/localization.service';

@Component({
  selector: 'app-forwarding-dashboard',
  standalone: true,
  imports: [CommonModule, LocalizationPipePipe],
  templateUrl: './forwarding-dashboard.html',
  styleUrl: './forwarding-dashboard.scss'
})
export class ForwardingDashboard implements OnInit {
  stats: QueueStats | undefined;
  loading = true;
  actionInProgress = false;
  error: string | undefined;
  successMessage: string | undefined;

  constructor(
    private readonly adminForwardingService: AdminForwardingService,
    private readonly cdr: ChangeDetectorRef,
    private readonly localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.loadStats().then();
  }

  async loadStats(): Promise<void> {
    this.loading = true;
    this.error = undefined;
    this.cdr.detectChanges();
    try {
      this.stats = await this.adminForwardingService.getQueueStats();
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : this.localizationService.getTranslation('admin.forwarding.error.load');
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  async onRetryFailed(): Promise<void> {
    this.actionInProgress = true;
    this.error = undefined;
    this.successMessage = undefined;
    this.cdr.detectChanges();
    try {
      await this.adminForwardingService.retryFailed();
      this.successMessage = this.localizationService.getTranslation('admin.forwarding.retrySuccess');
      await this.loadStats();
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : this.localizationService.getTranslation('admin.forwarding.error.action');
    } finally {
      this.actionInProgress = false;
      this.cdr.detectChanges();
    }
  }

  async onProcessQueue(): Promise<void> {
    this.actionInProgress = true;
    this.error = undefined;
    this.successMessage = undefined;
    this.cdr.detectChanges();
    try {
      await this.adminForwardingService.triggerProcessing();
      this.successMessage = this.localizationService.getTranslation('admin.forwarding.processSuccess');
      await this.loadStats();
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : this.localizationService.getTranslation('admin.forwarding.error.action');
    } finally {
      this.actionInProgress = false;
      this.cdr.detectChanges();
    }
  }
}
